import React from 'react';
import PropTypes from 'prop-types';
import { withNotifications } from './NotificationsContext';
import { Dagger } from './NotificationsTrigger';
import { combineClassNames } from 'core/css';

class Target extends React.Component {
  static defaultProps = {
    as: 'span',
    stopPropagation: false
  };

  onClick = event => {
    const { notifications, disclaimer, stopPropagation } = this.props;
    if (stopPropagation) {
      event.stopPropagation();
    }
    notifications.show(disclaimer, event.nativeEvent);
  };

  render() {
    const {
      notifications,
      children,
      as: Type,
      className,
      disclaimer
    } = this.props;
    const { disabled } = notifications;

    if (disabled || !disclaimer) {
      return <Type className={className}>{children}</Type>;
    }

    return (
      <React.Fragment>
        <Type
          className={combineClassNames(['disclaimer', className])}
          onClick={this.onClick}>
          {children} <Dagger />
        </Type>
        <div className="show-for-sr">{disclaimer}</div>
      </React.Fragment>
    );
  }
}

Target.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
  disclaimer: PropTypes.string.isRequired,
  stopPropagation: PropTypes.bool
};

export default withNotifications(Target);
